import { ArrowCounterClockwise } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import type { MatchingResponse } from "./types";

interface Props {
  fallback: NonNullable<MatchingResponse["fallback"]>;
  onRestart: () => void;
}

export function MatchingFallback({ fallback, onRestart }: Props) {
  return (
    <div className="rounded-xl border bg-card p-5">
      <h2 className="text-lg font-semibold text-foreground" style={{ fontFamily: "var(--font-heading)" }}>
        {fallback.reason === "no_candidates" ? "Nema dovoljno podudaranja" : "Prikazano je manje od dvije preporuke"}
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Trenutno nemamo dovoljno terapeuta koji odgovaraju svim odabranim uslovima. Možete proširiti kriterije ili pregledati listu terapeuta ručno.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button type="button" variant="outline" onClick={onRestart}>
          <ArrowCounterClockwise className="size-4" />
          Promijeni odgovore
        </Button>
        <Button asChild>
          <a href={fallback.therapistListUrl}>Pregledaj terapeute</a>
        </Button>
      </div>
    </div>
  );
}
